import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

/**DATOS INICIALES */
const dataInicial = {
    usuariosAtencionACliente: [],
    estadisticaUsuario: {},
    dataCartera: [],
    usuariosBeneficiarios: [],
    solicitudesDictamenes: [],
    informacionClienteDictamen: [],
    carteras: []
}

const OBTENER_USUARIOS_ATENCION_A_CLIENTES_EXITO = 'OBTENER_USUARIOS_ATENCION_A_CLIENTES_EXITO'
const AGREGAR_USUARIO_ATENCION_A_CLIENTES_EXITO = 'AGREGAR_USUARIO_ATENCION_A_CLIENTES_EXITO'
const VERIFICAR_USUARIO_EXITO = 'VERIFICAR_USUARIO_EXITO'
const ELIMINAR_USUARIO_ATENCION_A_CLIENTES_EXITO = 'ELIMINAR_USUARIO_ATENCION_A_CLIENTES_EXITO'
const ACTUALIZAR_USUARIO_ATENCION_A_CLIENTES_EXITO = 'ACTUALIZAR_USUARIO_ATENCION_A_CLIENTES_EXITO'
const OBTERNER_ESTADISTICAS_USUARIO_EXITO = 'OBTERNER_ESTADISTICAS_USUARIO_EXITO'
const OBTERNER_CARTERAS_EXITO = 'OBTERNER_CARTERAS_EXITO'
const REASIGNACION_DE_CARTERA_EXITO = 'REASIGNACION_DE_CARTERA_EXITO'
const OBTENER_CATERA_CON_ASOCIADOS_EXITO = 'OBTENER_CATERA_CON_ASOCIADOS_EXITO'
const OBTENER_LOGIN_TIPO_USUARIO = 'OBTENER_LOGIN_TIPO_USUARIO'
const ACTUALIZAR_LOGIN = 'ACTUALIZAR_LOGIN'
const GENERAR_DICTAMEN_JURIDICO_EXITO = 'GENERAR_DICTAMEN_JURIDICO_EXITO'
const GENERAR_DICTAMEN_FISCAL_EXITO = 'GENERAR_DICTAMEN_FISCAL_EXITO'
const GENERAR_DICTAMEN_MARCARIO_EXITO = 'GENERAR_DICTAMEN_MARCARIO_EXITO'
const OBTENER_SOLICITUDES_DICTAMENES_EXITO = 'OBTENER_SOLICITUDES_DICTAMENES_EXITO'
const OBTENER_DETALLE_CLIENTE_DICTAMEN_EXITO = 'OBTENER_DETALLE_CLIENTE_DICTAMEN_EXITO'
const OBTENER_DICTAMENES_FISCAL_EXITO = 'OBTENER_DICTAMENES_FISCAL_EXITO'
const ACTUALIZAR_DICTAMEN_FISCAL_EXITO = 'ACTUALIZAR_DICTAMEN_FISCAL_EXITO'
const ACTUALIZAR_DICTAMEN_JURIDICO_EXITO = 'ACTUALIZAR_DICTAMEN_JURIDICO_EXITO'
const OBTENER_DICTAMENES_JURIDICO_EXITO = 'OBTENER_DICTAMENES_JURIDICO_EXITO'
const OBTENER_FOLIO_DICTAMEN_OFICIO = 'OBTENER_FOLIO_DICTAMEN_OFICIO'
const ACTUALIZAR_FOLIO_DICTAMEN_OFICIO = 'ACTUALIZAR_FOLIO_DICTAMEN_OFICIO'
const OBTENER_DICTAMENES_FISCAL_ANO_EXITO = 'OBTENER_DICTAMENES_FISCAL_ANO_EXITO'
const OBTENER_DICTAMENES_JURIDICO_ANO_EXITO = 'OBTENER_DICTAMENES_JURIDICO_ANO_EXITO'
const ELIMINAR_DICTAMEN_MARCARIO_EXITO = 'ELIMINAR_DICTAMEN_MARCARIO_EXITO'
const ACTUALIZAR_DICTAMEN_MARCARIO_EXITO = 'ACTUALIZAR_DICTAMEN_MARCARIO_EXITO'
const OBTENER_DICTAMENES_MARCARIO_YEAR_EXITO = 'OBTENER_DICTAMENES_MARCARIO_YEAR_EXITO'
const ACTUALIZAR_MARCA_CLIENTE_BEBIDAS_EXITO = 'ACTUALIZAR_MARCA_CLIENTE_BEBIDAS_EXITO'
const ACTUALIZAR_MARCA_CLIENTE_EXITO = 'ACTUALIZAR_MARCA_CLIENTE_EXITO'
const OBTENER_CARTERA_CON_EJECUTIVO_EXITO = 'OBTENER_CARTERA_CON_EJECUTIVO_EXITO'
const ACTUALIZAR_CARTERA = 'ACTUALIZAR_CARTERA'
const ACTUALIZAR_CLIENTE_CARTERA_EXITO = 'ACTUALIZAR_CLIENTE_CARTERA_EXITO'
const AGREGAR_CARTERA_EXITO = 'AGREGAR_CARTERA_EXITO'
export const obtenerUsuariosAtencionACliente = createAsyncThunk(
    OBTENER_USUARIOS_ATENCION_A_CLIENTES_EXITO,
    async () => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerUsersAtencionACliente`
            const res = await axios.get(fullUrl)
            let usuarios = []
            for (const usuario of res.data.data) {
                if (usuario.datoslogin !== null) {
                    usuarios.push(usuario)
                }
            }
            return usuarios
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarUsuarioAtencionACliente = createAsyncThunk(
    AGREGAR_USUARIO_ATENCION_A_CLIENTES_EXITO,
    async (data) => {
        try {
            const urlAgregarLogin = host + `AnexoUsuario/agregarLogin`
            const urlAgregarDatoLogin = host + `AnexoUsuario/agregarDatoLogin`
            const urlObtenerCartera = host + `AnexoUsuario/obtenerCartera/${Number(data?.idcartera)}`
            /*const urlAgregarCartera = host + `AnexoUsuario/agregarCartera`

            const dataCartera = {
                nombrecartera: data.cartera
            }
            let resDataCartera = null
            if (data.cartera) {
                resDataCartera = await axios.post(urlAgregarCartera, { data: dataCartera })
            }*/

            const dataDatoLogin = {
                nombre: data.nombre,
                apellidos: data.apellidos,
                telefono: data.telefono + '',
                idcartera: Number(data.idcartera)
            }
            //if (resDataCartera !== null) dataDatoLogin.idcartera = resDataCartera.data.data.idcartera
            const resDataCartera = await axios.get(urlObtenerCartera)

            const resDataLogin = await axios.post(urlAgregarDatoLogin, { data: dataDatoLogin })
            const dataLogin = {
                usuario: data.usuario,
                password: data.password,
                idtipousuario: 3,
                iddatoslogin: resDataLogin.data.data.iddatoslogin
            }

            if (data.puesto === 'Jefe de atención a cliente') {
                dataLogin.idrol = 1
            }
            if (data.puesto === 'Ejecutivo') {
                dataLogin.idrol = 2
            }


            const resLogin = await axios.post(urlAgregarLogin, dataLogin)
            const resData = resLogin.data.data.nuevoUsuario
            resData.datoslogin = resDataLogin.data.data

            resData.datoslogin.cartera = resDataCartera.data.data

            return resData

        } catch (error) {
            console.log(error)
        }
    }
)
export const verificarUsuario = createAsyncThunk(
    VERIFICAR_USUARIO_EXITO,
    async (usuario) => {
        try {
            const urlVerificarUsuario = host + `AnexoUsuario/verificarUsuario/${usuario}`
            const resVerificarUsuario = await axios.get(urlVerificarUsuario)
            return resVerificarUsuario.data.data.usuarioExiste
        } catch (error) {
            console.log(error)
        }
    }
)

export const eliminarUsuarioAtencionACliente = createAsyncThunk(
    ELIMINAR_USUARIO_ATENCION_A_CLIENTES_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `AnexoUsuario/eliminarDatoLogin/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarUsuarioAtencionACliente = createAsyncThunk(
    ACTUALIZAR_USUARIO_ATENCION_A_CLIENTES_EXITO,
    async (data) => {
        try {
            const urlActualizarLogin = host + `AnexoUsuario/actualizarLogin`
            const urlActualizarDatoLogin = host + `AnexoUsuario/actualizarDatoLogin`
            const urlActualizarCartera = host + `AnexoUsuario/actualizarCartera`
            const dataCartera = {
                idcartera: data.usuarioModify.datoslogin.cartera?.idcartera,
                nombrecartera: data.usuario.cartera
            }
            let resDataCartera = null
            if (data.usuarioModify.datoslogin.cartera !== null) {
                resDataCartera = await axios.put(urlActualizarCartera, { data: dataCartera })
            }

            const dataDatoLogin = {
                iddatoslogin: data.usuarioModify.datoslogin.iddatoslogin,
                nombre: data.usuario.nombre,
                apellidos: data.usuario.apellidos,
                telefono: data.usuario.telefono + '',
            }
            const resDataLogin = await axios.put(urlActualizarDatoLogin, { data: dataDatoLogin })

            const dataLogin = {
                idlogin: data.usuarioModify.idlogin,
                usuario: data.usuario.usuario,
                idtipousuario: 3,
                iddatoslogin: dataDatoLogin.iddatoslogin
            }
            if (data.usuarioModify.password !== data.usuario.password) {
                dataLogin.password = data.usuario.password
            }
            if (data.usuario.puesto == 'Jefe de atención a cliente') {
                dataLogin.idrol = 1
            }
            if (data.usuario.puesto == 'Ejecutivo') {
                dataLogin.idrol = 2
            }

            const resLogin = await axios.put(urlActualizarLogin, { data: dataLogin })

            const resData = resLogin.data.data
            resData.datoslogin = resDataLogin.data.data
            if (resDataCartera !== null) resData.datoslogin.cartera = resDataCartera.data.data

            return resData
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarLogin = createAsyncThunk(
    ACTUALIZAR_LOGIN,
    async (data) => {
        try {
            const urlActualizarLogin = host + `AnexoUsuario/actualizarLogin`
            const resLogin = await axios.put(urlActualizarLogin, { data: data })
            return resLogin
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerEstadisticas = createAsyncThunk(
    OBTERNER_ESTADISTICAS_USUARIO_EXITO,
    async (data) => {
        try {
            const urlObtenerEstadisticas = host + `Estatus/obtenerEstadisticasUsuarioAtencionACliente/usuario=${data.usuario}&fechaInicio=${data.rangoInicio}&fechaFin=${data.rangoFin}`
            const resObtenerEstadisticas = await axios.get(urlObtenerEstadisticas)
            return resObtenerEstadisticas.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerCarteras = createAsyncThunk(
    OBTERNER_CARTERAS_EXITO,
    async () => {
        try {
            const urlObtenerCarteras = host + `AnexoUsuario/obtenerTodasLasCarteras`
            const resObtenerCarteras = await axios.get(urlObtenerCarteras)
            return resObtenerCarteras.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const reasignacionDeCartera = createAsyncThunk(
    REASIGNACION_DE_CARTERA_EXITO,
    async (data) => {
        try {
            const urlReasignacionCartera = host + `AnexoUsuario/actualizarDatoLogin`

            const dataCartera = {
                iddatoslogin: data.usuarioModify.datoslogin.iddatoslogin,
                idcartera: data.cartera.id
            }
            const resReasignacionCartera = await axios.put(urlReasignacionCartera, { data: dataCartera })

            let idCarter = resReasignacionCartera.data.data.idcartera

            const urlObtenerCartera = host + `AnexoUsuario/obtenerCartera/${idCarter}`
            const resObtenerCartera = await axios.get(urlObtenerCartera)

            const { datoslogin, ...userModify } = data.usuarioModify
            const { cartera, idcartera, ...restDatosLogin } = datoslogin


            const resData = userModify
            resData.datoslogin = restDatosLogin
            resData.datoslogin.idcartera = resObtenerCartera.data.data.idcartera
            resData.datoslogin.cartera = resObtenerCartera.data.data

            return resData
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerCarteraConAsociados = createAsyncThunk(
    OBTENER_CATERA_CON_ASOCIADOS_EXITO,
    async (cartera) => {
        try {
            const urlObtenerAsociadosDeEjecutivo = host + `AtencionAClientes/obtenerCarteraConAsociados/${cartera}`
            const resObtenerAsociadosDeEjecutivo = await axios.get(urlObtenerAsociadosDeEjecutivo)
            return resObtenerAsociadosDeEjecutivo.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerCarteraConClientes = createAsyncThunk(
    OBTENER_CATERA_CON_ASOCIADOS_EXITO,
    async (idcartera) => {
        try {
            const urlObtenerAsociadosDeEjecutivo = host + `AtencionAClientes/obtenerCarteraConClientes/${idcartera}`
            const resObtenerAsociadosDeEjecutivo = await axios.get(urlObtenerAsociadosDeEjecutivo)
            return resObtenerAsociadosDeEjecutivo.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerLoginPorTipoUsuario = createAsyncThunk(
    OBTENER_LOGIN_TIPO_USUARIO,
    async (id) => {
        try {
            const urlObtener = host + `AnexoUsuario/obtenerLoginPorTipoUsuario/${id}`
            const resObtener = await axios.get(urlObtener)
            return resObtener.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerClientesParaDictamen = createAsyncThunk(
    OBTENER_SOLICITUDES_DICTAMENES_EXITO,
    async () => {
        try {
            const fullUrl = host + `Clientes/obtenerTodosClientes`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerClienteParaDictamenes = createAsyncThunk(
    OBTENER_DETALLE_CLIENTE_DICTAMEN_EXITO,
    async (idcliente) => {
        try {
            const fullUrl = host + `Clientes/obtenerClienteParaDictamenes/${idcliente}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const AgregarDictamenFiscal = createAsyncThunk(
    GENERAR_DICTAMEN_FISCAL_EXITO,
    async (data) => {
        try {
            const fullUrlAgregarDictamen = host + `Clientes/agregarDictamenFiscal`
            const fullUrlGenerarDictamen = host + `AtencionAClientes/generarDictamenFiscal`

            const res = await axios.post(fullUrlAgregarDictamen, { data: data })
            await axios.post(fullUrlGenerarDictamen, { data: res?.data?.data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const ActualizarDictamenFiscal = createAsyncThunk(
    ACTUALIZAR_DICTAMEN_FISCAL_EXITO,
    async (data) => {
        try {
            const fullUrlActualizarDictamen = host + `Clientes/actualizarDictamenFiscal`
            const fullUrlGenerarDictamen = host + `AtencionAClientes/generarDictamenFiscal`

            const res = await axios.put(fullUrlActualizarDictamen, { data: data })
            await axios.post(fullUrlGenerarDictamen, { data: res?.data?.data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerDictamenFiscal = createAsyncThunk(
    OBTENER_DICTAMENES_FISCAL_EXITO,
    async (idcliente) => {
        try {
            const fullUrl = host + `Clientes/obtenerDictamenFiscal/${idcliente}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerDictamenesFiscalesByYear = createAsyncThunk(
    OBTENER_DICTAMENES_FISCAL_ANO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Clientes/obtenerDictamenesFiscalesByYear/${year}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const AgregarDictamenJuridico = createAsyncThunk(
    GENERAR_DICTAMEN_JURIDICO_EXITO,
    async (data) => {
        try {
            const fullUrlAgregarDictamen = host + `Clientes/agregarDictamenJuridico`
            const fullUrlGenerarDictamen = host + `AtencionAClientes/generarDictamenJuridico`

            const res = await axios.post(fullUrlAgregarDictamen, { data: data })
            await axios.post(fullUrlGenerarDictamen, { data: res.data.data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const ActualizarDictamenJuridico = createAsyncThunk(
    ACTUALIZAR_DICTAMEN_JURIDICO_EXITO,
    async (data) => {
        try {
            const fullUrlActualizarDictamen = host + `Clientes/actualizarDictamenJuridico`
            const fullUrlGenerarDictamen = host + `AtencionAClientes/generarDictamenJuridico`

            const res = await axios.put(fullUrlActualizarDictamen, { data: data })
            await axios.post(fullUrlGenerarDictamen, { data: res.data.data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerDictamenJuridico = createAsyncThunk(
    OBTENER_DICTAMENES_JURIDICO_EXITO,
    async (idcliente) => {
        try {
            const fullUrl = host + `Clientes/obtenerDictamenJuridico/${idcliente}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerDictamenesJuridicoByYear = createAsyncThunk(
    OBTENER_DICTAMENES_JURIDICO_ANO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Clientes/obtenerDictamenesJuridicoByYear/${year}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerCarteraConEjecutivo = createAsyncThunk(
    OBTENER_CARTERA_CON_EJECUTIVO_EXITO,
    async () => {
        try {
            const urlObtenerAsociadosDeEjecutivo = host + `AnexoUsuario/obtenerTodasLasCarterasEjecutivo`
            const res = await axios.get(urlObtenerAsociadosDeEjecutivo)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const AgregarDictamenMarcario = createAsyncThunk(
    GENERAR_DICTAMEN_MARCARIO_EXITO,
    async (data) => {
        try {
            const { imgexportacion, imgnacional, imgregistrado, ...informacion } = data

            const fullUrlAgregarDictamen = host + `Clientes/agregarDictamenMarcario`
            const fullUrl = host + `AtencionAClientes/generarDictamenMarcario`
            const fullUrlImgRegistrado = host + `AtencionAClientes/agregarImgRegistradoMarcario`
            const fullUrlImgExportacion = host + `AtencionAClientes/agregarImgExportacionMarcario`
            const fullUrlImgNacional = host + `AtencionAClientes/agregarImgNacionalMarcario`

            const res = await axios.post(fullUrlAgregarDictamen, { data: informacion })
            if (imgregistrado.length > 0) {
                for (const i in imgregistrado) {
                    let formData = new FormData();
                    formData.append(0, imgregistrado[i])
                    formData.append('iddictamenmarcariocliente', res?.data?.data?.iddictamenmarcariocliente)
                    formData.append('idcliente', res?.data?.data?.idcliente)
                    formData.append('ruta', '')
                    const resFile = await axios.post(fullUrlImgRegistrado, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                }
            }

            if (informacion.exportacion) {
                for (const i in imgexportacion) {

                    let formData = new FormData();
                    formData.append(0, imgexportacion[i])
                    formData.append('iddictamenmarcariocliente', res?.data?.data?.iddictamenmarcariocliente)
                    formData.append('idcliente', res?.data?.data?.idcliente)
                    formData.append('ruta', '')
                    const resFile = await axios.post(fullUrlImgExportacion, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                }
            }
            if (informacion.nacional) {
                for (const i in imgnacional) {
                    let formData = new FormData();
                    formData.append(0, imgnacional[i])
                    formData.append('iddictamenmarcariocliente', res?.data?.data?.iddictamenmarcariocliente)
                    formData.append('idcliente', res?.data?.data?.idcliente)
                    formData.append('ruta', '')
                    const resFile = await axios.post(fullUrlImgNacional, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                }
            }

            await axios.post(fullUrl, { data: res.data.data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const ActualizarDictamenMarcario = createAsyncThunk(
    ACTUALIZAR_DICTAMEN_MARCARIO_EXITO,
    async (data) => {
        try {
            const { imgexportacion, imgnacional, imgregistrado, ...informacion } = data
            const fullUrlActualizarDictamen = host + `Clientes/actualizarDictamenMarcario`
            const fullUrlGenerarDictamen = host + `AtencionAClientes/generarDictamenMarcario`
            const fullUrlEliminarImgRegistro = host + `AtencionAClientes/eliminarImgRegistroMarcario/${informacion?.iddictamenmarcariocliente}`
            const fullUrlEliminarImgExportacion = host + `AtencionAClientes/eliminarImgExportacionMarcario/${informacion?.iddictamenmarcariocliente}`
            const fullUrlEliminarImgNacional = host + `AtencionAClientes/eliminarImgNacionalMarcario/${informacion?.iddictamenmarcariocliente}`

            const fullUrlImgRegistrado = host + `AtencionAClientes/agregarImgRegistradoMarcario`
            const fullUrlImgExportacion = host + `AtencionAClientes/agregarImgExportacionMarcario`
            const fullUrlImgNacional = host + `AtencionAClientes/agregarImgNacionalMarcario`

            await axios.delete(fullUrlEliminarImgRegistro)
            await axios.delete(fullUrlEliminarImgExportacion)
            await axios.delete(fullUrlEliminarImgNacional)

            const res = await axios.put(fullUrlActualizarDictamen, { data: informacion })
            if (imgregistrado.length > 0) {
                for (const i in imgregistrado) {
                    let formData = new FormData();
                    formData.append(0, imgregistrado[i])
                    formData.append('iddictamenmarcariocliente', res?.data?.data?.iddictamenmarcariocliente)
                    formData.append('idcliente', res?.data?.data?.idcliente)
                    formData.append('ruta', '')
                    const resFile = await axios.post(fullUrlImgRegistrado, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                }
            }
            if (informacion.exportacion) {
                for (const i in imgexportacion) {
                    let formData = new FormData();
                    formData.append(0, imgexportacion[i])
                    formData.append('iddictamenmarcariocliente', res?.data?.data?.iddictamenmarcariocliente)
                    formData.append('idcliente', res?.data?.data?.idcliente)
                    formData.append('ruta', '')
                    const resFile = await axios.post(fullUrlImgExportacion, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                }
            }
            if (informacion.nacional) {
                for (const i in imgnacional) {
                    let formData = new FormData();
                    formData.append(0, imgnacional[i])
                    formData.append('iddictamenmarcariocliente', res?.data?.data?.iddictamenmarcariocliente)
                    formData.append('idcliente', res?.data?.data?.idcliente)
                    formData.append('ruta', '')
                    const resFile = await axios.post(fullUrlImgNacional, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                }
            }
            await axios.post(fullUrlGenerarDictamen, { data: res.data.data })

            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerDictamenesMarcarioByYear = createAsyncThunk(
    OBTENER_DICTAMENES_MARCARIO_YEAR_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Clientes/obtenerDictamenesMarcarioByYear/${year}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const EliminarDictamenMarcario = createAsyncThunk(
    ELIMINAR_DICTAMEN_MARCARIO_EXITO,
    async (id) => {
        try {
            const fullUrlAgregarDictamen = host + `Clientes/eliminarDictamenMarcario/${id}`

            const res = await axios.delete(fullUrlAgregarDictamen)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFolioDictamen = createAsyncThunk(
    OBTENER_FOLIO_DICTAMEN_OFICIO,
    async (id) => {
        try {
            const fullUrl = host + `Clientes/obtenerFolioDictamen/${id}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarFolioOficioDictamen = createAsyncThunk(
    ACTUALIZAR_FOLIO_DICTAMEN_OFICIO,
    async (data) => {
        try {
            const fullUrl = host + `Clientes/actualizarFolioDictamen`
            const res = await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const ActualizarMarcaMezcalCliente = createAsyncThunk(
    ACTUALIZAR_MARCA_CLIENTE_EXITO,
    async (data) => {
        try {
            const fullUrlActualizarMarca = host + `InformacionValida/actualizarMarcasCliente`
            const res = await axios.put(fullUrlActualizarMarca, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const ActualizarMarcaBebidasCliente = createAsyncThunk(
    ACTUALIZAR_MARCA_CLIENTE_BEBIDAS_EXITO,
    async (data) => {
        try {
            const fullUrlActualizarMarca = host + `InformacionValida/actualizarMarcasProductoConMezcalCliente`
            const res = await axios.put(fullUrlActualizarMarca, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const ActualizarCartera = createAsyncThunk(
    ACTUALIZAR_CARTERA,
    async (data) => {
        try {
            const fullUrlActualizarCartera = host + `AnexoUsuario/actualizarCartera`
            const res = await axios.put(fullUrlActualizarCartera, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarCliente = createAsyncThunk(
    ACTUALIZAR_CLIENTE_CARTERA_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `InformacionValida/actualizarCliente`
            for (const i in data.clientes) {
                let dataCliente = { idcliente: data.clientes?.[i]?.idcliente, idcartera: Number(data.idcartera) }
                await axios.put(fullUrl, { data: dataCliente })
            }
            return true
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarCartera = createAsyncThunk(
    AGREGAR_CARTERA_EXITO,
    async (data) => {
        try {
            const urlAgregarCartera = host + `AnexoUsuario/agregarCartera`
            let resDataCartera = await axios.post(urlAgregarCartera, { data: data })
            return resDataCartera.data.data

        } catch (error) {
            console.log(error)
        }
    }
)





export const UsuariosAtencionAClienteSlice = createSlice({
    initialState: dataInicial,
    name: 'InspectorSlice',
    reducers: {
        eliminarAtencionACliente(state, { payload }) {
            const filteredInspectores = state.usuariosAtencionACliente.filter(usuario => usuario.id !== payload)
            state.usuariosAtencionACliente = filteredInspectores
        }
    },
    extraReducers: {
        [obtenerUsuariosAtencionACliente.fulfilled]: (state, { payload }) => {
            state.usuariosAtencionACliente = payload
        },
        [agregarUsuarioAtencionACliente.fulfilled]: (state, { payload }) => {
            state.usuariosAtencionACliente.push(payload)
        },
        [verificarUsuario.fulfilled]: (state, { payload }) => {
            // return payload
        },
        [eliminarUsuarioAtencionACliente.fulfilled]: (state, { payload }) => {
            const filtro = { data: state.usuariosAtencionACliente.filter(anexo => anexo.iddatoslogin !== Number(payload)) }
            state.usuariosAtencionACliente = filtro.data
        },
        [actualizarUsuarioAtencionACliente.fulfilled]: (state, { payload }) => {
            const filtro = state.usuariosAtencionACliente.filter(anexo => anexo.iddatoslogin !== Number(payload.iddatoslogin))
            filtro.push(payload)
            state.usuariosAtencionACliente = filtro
        },
        [obtenerEstadisticas.fulfilled]: (state, { payload }) => {
            // state.estadisticaUsuario = payload  
        },
        [obtenerCarteras.fulfilled]: (state, { payload }) => {

        },
        [reasignacionDeCartera.fulfilled]: (state, { payload }) => {
            const filtro = state.usuariosAtencionACliente.filter(anexo => anexo.iddatoslogin !== Number(payload.iddatoslogin))
            filtro.push(payload)
            state.usuariosAtencionACliente = filtro
        },
        [obtenerCarteraConAsociados.fulfilled]: (state, { payload }) => {
            state.dataCartera = payload
        },
        [obtenerLoginPorTipoUsuario.fulfilled]: (state, { payload }) => {
            state.usuariosBeneficiarios = payload
        },
        [obtenerClientesParaDictamen.fulfilled]: (state, { payload }) => {
            state.solicitudesDictamenes = payload
        },
        [obtenerClienteParaDictamenes.fulfilled]: (state, { payload }) => {
            state.informacionClienteDictamen = payload
        },
        [obtenerCarteraConEjecutivo.fulfilled]: (state, { payload }) => {
            state.carteras = payload
        },
    },
})

export const {
    eliminarAtencionACliente,
} = UsuariosAtencionAClienteSlice.actions

export const UsuariosAtencionAClienteReducer = UsuariosAtencionAClienteSlice.reducer